import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { CHAT_MODELS, chatModel, chatPriceHint } from "@joogoos/contracts";
import { useWorkspace } from "./workspace.js";
import { api } from "../api.js";

/**
 * Who answers in the chat box (04).
 *
 * The one model choice that belongs to the customer. The pipeline picks its own — nobody running a bakery knows
 * which image model handles a shopfront well, and there is no reason they should — but the assistant they talk to
 * is a matter of taste and of price, so both are on the control that changes it.
 */
export function ChatModelPicker({ compact }: { compact?: boolean }) {
  const qc = useQueryClient();
  const ws = useWorkspace();
  const choose = useMutation({
    mutationFn: api.chooseChatModel,
    onSuccess: () => qc.invalidateQueries({ queryKey: ["workspace"] }),
  });
  const current = chatModel(ws.data?.chatModel);

  return (
    <label className="flex items-center gap-1.5 min-w-0" title={`${current.maker} ${current.name} — ${chatPriceHint(current)}`}>
      <span className="sr-only">Which assistant answers</span>
      <select
        value={current.id}
        onChange={(e) => choose.mutate(e.target.value)}
        disabled={choose.isPending}
        className="max-w-[168px] truncate bg-transparent text-[11.5px] text-muted hover:text-ink outline-none cursor-pointer disabled:opacity-50"
      >
        {CHAT_MODELS.map((m) => (
          <option key={m.id} value={m.id}>
            {m.maker} {m.name}{compact ? "" : ` — ${chatPriceHint(m)}`}
          </option>
        ))}
      </select>
    </label>
  );
}
